import React from "react";
import { useSelector } from "react-redux";
import { getSortTranslation } from "../helper";

const options = [
  ["Low to High", "price-low-to-high", "Price"],
  ["High to Low", "price-high-to-low", "Price"],
  ["A to Z", "name-a-to-z", "Name"],
  ["Z to A", "name-z-to-a", "Name"],
  ["Newest", "newest", "Date"],
  ["Oldest", "oldest", "Date"],
];

export default function SortByFilter({ setSortOption, sortOption }) {
  const arabic = useSelector(state => state.store.language) === "arabic";
  return <section className="sf-filter-sort" dir={arabic ? "rtl" : "ltr"}>
    <div className="sf-filter-section-heading">
      <h2>{arabic ? "الترتيب" : "Sort by"}</h2>
      <button type="button" disabled={!sortOption.value} onClick={() => setSortOption({ filterName: "Sort By", filterOptionName: "", value: "" })}>{arabic ? "إعادة تعيين" : "Reset"}</button>
    </div>
    <div className="sf-filter-sort__options">
      {options.map(([name, value, title]) => <button type="button" key={value}
        aria-pressed={sortOption.value === value}
        onClick={() => setSortOption({ filterName: "Sort By", filterOptionName: sortOption.value === value ? "" : name, value: sortOption.value === value ? "" : value })}>
        <span>{arabic ? getSortTranslation(title) : title}</span>
        <strong>{arabic ? getSortTranslation(name) : name}</strong>
      </button>)}
    </div>
  </section>;
}
